import { useLocation } from "@remix-run/react";
import { useEffect } from "react";
import { Button } from "~/components/ui";
import { useLanguage } from "~/hooks/useLanguage";
import { commonTranslations } from "~/translations/common/common";
import { OF_CUSTOM_SCHEME_CALLBACK } from "~/utils/openFinanceNative";

/**
 * Shown in mobile Safari when the https callback is reached and the document
 * redirect to the app did not run. A tap is the reliable fallback.
 */
const OpenFinanceAppHandoff = () => {
  const { lang } = useLanguage();
  const ct = commonTranslations[lang];
  const { search } = useLocation();
  const href = `${OF_CUSTOM_SCHEME_CALLBACK}${search}`;

  useEffect(() => {
    window.location.replace(href);
  }, [href]);

  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-4 px-6 text-center">
      <script
        dangerouslySetInnerHTML={{
          __html: `window.location.replace(${JSON.stringify(href)});`,
        }}
      />
      <div className="text-2xl font-extrabold text-menu">{ct.returnToApp}</div>
      <div className="max-w-md text-menu/75">{ct.returnToAppDesc}</div>
      <Button as="a" href={href} variant="primary">
        {ct.returnToApp}
      </Button>
    </div>
  );
};

export default OpenFinanceAppHandoff;
